import { inject, Injectable } from '@angular/core';
import { isObservable, Observable, of, switchMap } from 'rxjs';

import { LicencesFactory } from 'app/factories';
import { LicenceQuery, LicenceTypeGraphQlEnumType } from 'app/graphql/generated/graphql-types';
import { QueryResult } from 'app/interfaces';

@Injectable()
export class LicencesService {
    private licencesFactory = inject(LicencesFactory);

    getLicences(
        licenceType: LicenceTypeGraphQlEnumType | Observable<LicenceTypeGraphQlEnumType>,
    ): Observable<QueryResult<LicenceQuery>> {
        const licenceType$ = isObservable(licenceType) ? licenceType : of(licenceType);

        return licenceType$.pipe(switchMap((type) => this.licencesFactory.getLicences({ types: [type] })));
    }
}
